import { User } from "etl/types"
import { createAppAsyncThunk } from "../../../../store/store.types"
import { displayApiErrorToast } from "core/src/slices/ui/useCases/display-api-error-toast/display-api-error-toast.use-case"

type LoadProfileResponse = {
	user: User
}

export const loadProfile = createAppAsyncThunk<LoadProfileResponse, void>(
	"auth/loadProfile",
	async (_, { dispatch, extra, rejectWithValue }) => {
		try {
			const resp = await extra.awClient.getProfile();
			const user = resp.data;

			extra.localStorage.setItem("user", JSON.stringify(user));

			return { user };
		} catch (e) {
			dispatch(displayApiErrorToast({ message: e as string }));
			return rejectWithValue(e);
		}
	}
)
